'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var AccessController = require('./access-controller-interface');

var AccessControllerManifest = require('./access-controller-manifest');

var LegacyIPFSAccessController = require('./legacy-ipfs-access-controller');

var IPFSAccessController = require('./ipfs-access-controller');

var OrbitDBAccessController = require('./orbitdb-access-controller');

var supportedTypes = {
  'legacy-ipfs': LegacyIPFSAccessController,
  ipfs: IPFSAccessController,
  orbitdb: OrbitDBAccessController
};

var getHandlerFor = function getHandlerFor(type) {
  if (!AccessControllers.isSupported(type)) {
    throw new Error("AccessController type '".concat(type, "' is not supported"));
  }

  return supportedTypes[type];
};

var AccessControllers = /*#__PURE__*/function () {
  function AccessControllers() {
    _classCallCheck(this, AccessControllers);
  }

  _createClass(AccessControllers, null, [{
    key: "AccessController",
    get: function get() {
      return AccessController;
    }
  }, {
    key: "isSupported",
    value: function isSupported(type) {
      return Object.keys(supportedTypes).includes(type);
    }
  }, {
    key: "addAccessController",
    value: function addAccessController(options) {
      if (!options.AccessController) {
        throw new Error('AccessController class needs to be given as an option');
      }

      if (!options.AccessController.type || typeof options.AccessController.type !== 'string') {
        throw new Error('Given AccessController class needs to implement: static get type() { /* return a string */}.');
      }

      supportedTypes[options.AccessController.type] = options.AccessController;
    }
  }, {
    key: "addAccessControllers",
    value: function addAccessControllers(options) {
      var accessControllers = options.AccessControllers;

      if (!accessControllers) {
        throw new Error('AccessController classes need to be given as an option');
      }

      accessControllers.forEach(function (accessController) {
        AccessControllers.addAccessController({
          AccessController: accessController
        });
      });
    }
  }, {
    key: "removeAccessController",
    value: function removeAccessController(type) {
      delete supportedTypes[type];
    }
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(orbitdb, manifestAddress) {
        var options,
            _yield$AccessControll,
            type,
            params,
            AccessController,
            accessController,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                _context.next = 3;
                return AccessControllerManifest.resolve(orbitdb._ipfs, manifestAddress, options);

              case 3:
                _yield$AccessControll = _context.sent;
                type = _yield$AccessControll.type;
                params = _yield$AccessControll.params;
                AccessController = getHandlerFor(type);
                _context.next = 9;
                return AccessController.create(orbitdb, Object.assign({}, options, params));

              case 9:
                accessController = _context.sent;
                _context.next = 12;
                return accessController.load(params.address);

              case 12:
                return _context.abrupt("return", accessController);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function resolve(_x, _x2) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(orbitdb, type) {
        var options,
            AccessController,
            ac,
            params,
            hash,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                AccessController = getHandlerFor(type);
                _context2.next = 4;
                return AccessController.create(orbitdb, options);

              case 4:
                ac = _context2.sent;
                _context2.next = 7;
                return ac.save();

              case 7:
                params = _context2.sent;
                _context2.next = 10;
                return AccessControllerManifest.create(orbitdb._ipfs, type, params);

              case 10:
                hash = _context2.sent;
                return _context2.abrupt("return", hash);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function create(_x3, _x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return AccessControllers;
}();

module.exports = AccessControllers;